import { z } from "zod";

const schema = z.object({
  VITE_PUBLIC_SUPABASE_URL: z.string().url(),
  VITE_PUBLIC_SUPABASE_ANON_KEY: z.string().min(1),
  REACT_APP_API_BASE_URL: z.string().optional(),
  REACT_APP_TITLE: z.string().optional(),
});

const parsed = schema.safeParse(import.meta.env);

if (!parsed.success) {
  console.error(
    "Invalid environment variables:",
    parsed.error.flatten().fieldErrors
  );
  throw new Error(
    "Invalid environment variables. See console for details. Did you run `vercel env pull`?"
  );
}

export const env = parsed.data;
